import React from 'react';
import PageBase from 'components/PageBase';
import { useDispatch, useSelector } from 'react-redux';
import { Creators as GlobalItemCreators } from 'store/ducks/global';
import { Creators as GlobalUpdateCreators } from 'store/ducks/global/update';
import { Paper } from '@material-ui/core';
import HeaderComponent from 'components/HeaderComponent';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
// import { push } from 'connected-react-router';
import TermsForm from 'components/Pages/ConfigPageGeneral/TermsForm';

const TermsPage = ({ match }) => {
  const dispatch = useDispatch();

  const [localState, setLocalState] = React.useState(null);

  const { global, globalLoading } = useSelector(state => state.global.global);
  const { globalUpdateLoading } = useSelector(state => state.global.update);

  const globalId = 1;

  const getInitialData = () => {
    dispatch(GlobalItemCreators.getGlobalRequest());
    setLocalState(null);
  };

  React.useEffect(() => {
    getInitialData();
  }, []);

  React.useEffect(() => {
    if (
      Object.keys(global).length > 0 &&
      !globalLoading &&
      global.id === Number(globalId)
    ) {
      setLocalState({
        ...global,
        logo_info: global.logo,
        logo: '',
      });
    }
  }, [global, match, globalLoading]);

  const onSubmit = data => {
    dispatch(GlobalUpdateCreators.getGlobalUpdateRequest(data));
  };

  return (
    <PageBase>
      <HeaderComponent title="Termos de Uso" />
      <Paper>
        {localState && (
          <TermsForm
            initialValues={localState}
            onSubmit={onSubmit}
            isLoading={globalUpdateLoading}
          />
        )}
      </Paper>
    </PageBase>
  );
};

TermsPage.propTypes = {
  match: PropTypes.oneOfType([PropTypes.object]).isRequired,
};

export default withRouter(TermsPage);
